<template>
  <UContainer class="px-1 sm:pb-12 md:pb-0">
    <h2 class="text-3xl md:text-4xl font-bold text-center text-[#01365A] mb-10">
      Conheça os cursos mais acessados
    </h2>
    <section class="w-full relative pb-12">
      <UCarousel v-slot="{ item }" :items="catalogStore.seo_courses"
                 arrows wheel-gestures prev-icon="ph:caret-left-bold" next-icon="ph:caret-right-bold" class="w-full"
                 :ui="{
                container: 'pl-1 h-136',
                // Mobile: Embaixo e centralizado | Desktop (md:): No meio vertical e nas pontas
                controls: 'absolute flex items-center gap-4 -bottom-10 inset-x-18 2xl:inset-x-9 justify-center ' +
                 'md:bottom-auto md:top-1/2 md:-translate-y-1/2 md:justify-between sm:mx-35 md:-mx-12',
                item: 'basis-[70%] sm:basis-[45%] lg:basis-[30%] pl-4' }">
        <CourseCard :course="item" showDetails titleSize="lg" tagAreaSize="xs" class="min-h-135"/>
      </UCarousel>
    </section>
  </UContainer>
</template>
<script setup lang="ts">

const catalogStore = useCatalogStore();

</script>
